import React from 'react';
import './Loading.css';

const Loading = () => {
    return (
        <div className="loading">
            Please grab some popcorn 🍟🍟 and get ready to explore!🚀🌍🔥
        </div>
    );
};

export default Loading;